



























import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { EButtonType } from '@getaccept/lib-ui';
import { initialHelper } from '@lib-shared/helpers';
import { SigningHelper } from '@signing-page/signing/helpers/signing.helper';

@Component({
  data: () => ({
    EButtonType,
  }),
})
export default class InitialsModal extends Vue {
  @Prop({ default: '' }) fullName: string;
  @Prop() initials: string;

  initialsInput = '';
  initialsValidation = '';

  @Watch('initials')
  watchInitials() {
    this.initialsValidation = '';
  }

  submit() {
    this.initialsValidation = SigningHelper.validateInitials(this.initialsInput);

    if (!this.initialsValidation) {
      this.$emit('submit', this.initialsInput.toUpperCase());
    }
  }

  cancel() {
    this.$emit('cancel');
  }

  mounted() {
    this.initialsInput = this.initials || initialHelper(this.fullName);
  }

  get headerText(): string {
    if (this.initials) {
      return this.$t('edit-initials').toString();
    }
    return this.$t('add-initials').toString();
  }
}
